<div class="bundle-tag-details__container">
  <ion-row class="bundle-tag-details__master-head"> {{ 'cutbank_common.master_bundle_tag' | translate }} </ion-row>
  <ion-row class="bundle-tag-details__master-card">
    <ion-col size="1.5" *ngFor="let field of masterBundleTag; let i = index">
      <div class="bundle-tag-details__master-card-head">
        {{ field.header }}
      </div>
      <div class="bundle-tag-details__master-card-value">
        {{ field.value }}
      </div>
    </ion-col>
    <ion-col size="1.5">
      <div class="bundle-tag-details__master-card-head">{{ 'cutbank_common.action' | translate }}</div>
      <div
        class="bundle-tag-details__master-card-expand-details"
        (click)="openExpandMasterBundleTagModal(bundleTagDetails)"
      >
        {{ 'cutbank_common.expan_details' | translate }}
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="bundle-tag-details__warning-container">
    <ion-icon class="bundle-tag-details__warning-icon" name="warning-outline"></ion-icon>
    <div class="bundle-tag-details__warning-text">
      {{ 'cutbank_common.equal_qty_to_generate_wip' | translate }}
    </div>
  </ion-row>

  <ion-row class="bundle-tag-details__component-head">
    <ion-col> {{ 'cutbank_common.component_bundle_tag' | translate }} </ion-col>
    <ion-col size="2">
      <ui-custom-button
        [btnTxt]="'cutbank_common.bulk_edit_tag_qty' | translate"
        [buttonType]="'TERITIARY'"
        (clickEvent)="openbulkEditTagQty()"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ui-table
        [zTableModel]="componentBundleTagTable"
        (onLinkClicked)="openExpandComponentBundleTagModal($event)"
      ></ui-table>
    </ion-col>
  </ion-row>
</div>
